import React from "react";

const QuizReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.904"
      height="38.629"
      viewBox="0 0 30.904 38.629"
    >
      <g id="db98" transform="translate(-224.46 -186.569)">
        <path
          id="Path_1829"
          data-name="Path 1829"
          d="M250.534,188.5H246.5a2.907,2.907,0,0,0-2.723-1.931h-7.726a2.908,2.908,0,0,0-2.723,1.931h-4.037a4.83,4.83,0,0,0-4.828,4.829v6.76h30.9v-6.76a4.83,4.83,0,0,0-4.829-4.829Zm-6.76,1.932h-7.726a.966.966,0,0,1,0-1.932h7.726a.966.966,0,0,1,0,1.932Z"
          fill="#ff7e7e"
        />
        <path
          id="Path_1830"
          data-name="Path 1830"
          d="M224.46,356.459a4.83,4.83,0,0,0,4.829,4.829h21.246a4.83,4.83,0,0,0,4.829-4.829V338.11h-30.9Zm4.828-14.485h21.246a.966.966,0,1,1,0,1.932H229.288a.966.966,0,1,1,0-1.932Zm0,5.795h21.246a.966.966,0,1,1,0,1.932H229.288a.966.966,0,1,1,0-1.931Zm0,5.794h21.246a.966.966,0,1,1,0,1.932H229.288a.966.966,0,1,1,0-1.932Z"
          transform="translate(0 -136.09)"
          fill="#ff7e7e"
        />
      </g>
    </svg>
  );
};

export default QuizReportIcon;
